<script lang="ts">
    import type {AxiosInstance} from 'axios';

    import {dyData} from 'general/store';
    import {TEMPLATE} from 'general/constants';
    import Form from 'general/components/form/email/Form.svelte';
    import Policy from 'general/components/policy/Policy.svelte';
    import OpacityItem from 'general/components/flip/opacityItem/OpacityItem.svelte';
    import Trustpilot from '../../components/trustpilot/Trustpilot.svelte';
    import Offer50 from 'desktop/icons/Offer50.svelte';

    import s from './style.module.css';

    export let instance: AxiosInstance;
    let errorMessage: string;
</script>

<OpacityItem delayIn={0}>
    <div class={s.main} style="margin-top: {$dyData.side.main?.marginTop || 0}">
        <div class={s.descWrapper}>
            <p class={s.desc} class:smallScreen={$dyData.isSmallerScreen}>
                Wait, we want to give you
            </p>
            <div class={s.imageWithDiscount} class:smallScreen={$dyData.isSmallerScreen}>
                <Offer50 />
            </div>
            <p class={s.firstFrame} class:smallScreen={$dyData.isSmallerScreen}>YOUR FIRST FRAME</p>
        </div>
        <Form
            {instance}
            label="Enter your email address"
            offerGiven={$dyData.offerGiven}
            template={TEMPLATE.SQUARE_EXIT_REDESIGN}
            marginBottom={errorMessage ? '26px' : '10px'}
            bind:errorMessage
        />
        <Trustpilot />
        <Policy side="main" />
    </div>
</OpacityItem>
